import { CreateUserRequest } from '@/api/generatedApi';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { AxiosApiError, getApiError } from '@/types/apiError';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { LIST_TENANT_USERS_QUERY_KEY } from './useFetchTenantUsers';

export const useCreateUser = () => {
  const queryClient = useQueryClient();
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();
  const { mutate, isPending, error, reset } = useMutation<
    Awaited<ReturnType<typeof api.users.createUser>>,
    AxiosApiError,
    CreateUserRequest
  >({
    mutationFn: (data: CreateUserRequest) => api.users.createUser(tenantId, data),
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: [LIST_TENANT_USERS_QUERY_KEY], exact: false });
    },
  });

  return {
    createUser: mutate,
    isCreating: isPending,
    error: getApiError(error),
    resetCreateUserError: reset,
  };
};
